import { Map, List, fromJS } from "immutable";
import { FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS, DELETE_TASK_DEPENDENCIES_SUCCESS } from "../action_types";

const initialProjectTasksDependenciesState = Map();
const projectTasksDependencies = (state = initialProjectTasksDependenciesState, action) => {
  if (!action.type || !action.projectId) return state;
  switch (action.type) {
    case FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS:
      return state.set(`${action.projectId}`, fromJS(action.response));
    case DELETE_TASK_DEPENDENCIES_SUCCESS: {
      const deletedDependency = [`${action.taskId}`, `${action.dependency_id}`];
      return state.set(
        `${action.projectId}`,
        state.get(`${action.projectId}`, List()).filter((dependency) => {
          if (
            deletedDependency.indexOf(`${dependency.get(`parent_id`)}`) > -1 &&
            deletedDependency.indexOf(`${dependency.get(`child_id`)}`) > -1
          ) {
            return false;
          }
          return true;
        })
      );
    }
    default:
      return state;
  }
};

export default projectTasksDependencies;
